module.exports = __webpack_public_path__ + "img/diw_16_RecPay.86c84c4f.png";